import type { Answer } from "@pulse/api/answersAPI";
import { createContext } from "react";

export const CommentContext = createContext<{ answer: Answer } | null>(null);
